//quiz results.
import { getQuizResult } from "../services/quizResults";

/**
 * Get result of quiz
 * @param quizId
 * @returns {{status: string}}
 */
export const getQuizResultResponse = (slug, courseId) => (dispatch) => {
    // get quiz result.
    dispatch({ type: "QUIZ_RESULT_REQUEST", payload: {} });
    return getQuizResult(slug, courseId)
        .then((data) => {
            dispatch({ type: "QUIZ_RESULT_SUCCESS", payload: data });
            return data;
        })
        .catch((error) => {
            const errorPayload = error?.response?.data || { message: 'An unknown error occurred' };
            dispatch({ type: "QUIZ_RESULT_ERORR", payload: errorPayload });
            return errorPayload;
        });
};

export const setQuizLoading = (isLoading) => ({
    type: "SET_QUIZ_LOADING",
    payload: isLoading,
});
